import { FC, useEffect } from "react";

import { BaseComponentProps, KContactSheetsModal } from "@keepeek/refront-components";
import { useRecoilState } from "recoil";

import {
  contactSheetsModalSelectedContactSheetState,
  contactSheetsModalSelectedOrientationState,
  contactSheetsModalSelectedValueState,
} from "../../providers/contactSheet/atoms/selections";
import useContactSheetSelections from "../../providers/contactSheet/hooks/useContactSheetSelections";

export type ContactSheetsProps = {} & BaseComponentProps;

const ContactSheets: FC<React.PropsWithChildren<ContactSheetsProps>> = function ({
  id = "contactSheetsModal",
  testId = "contactSheets",
  className,
}) {
  const { open, close, count, loading, contactSheetList, onSelectContactSheet } =
    useContactSheetSelections();

  const [value, setValue] = useRecoilState(contactSheetsModalSelectedValueState);
  const [orientation, setOrientation] = useRecoilState(contactSheetsModalSelectedOrientationState);
  const [selectedContactSheet, setSelectedContactSheet] = useRecoilState(
    contactSheetsModalSelectedContactSheetState,
  );

  useEffect(() => {
    if (contactSheetList && contactSheetList.length > 0) {
      setValue(contactSheetList[0].id);
      setSelectedContactSheet(contactSheetList[0]);
      setOrientation(contactSheetList[0].orientation);
    }
    // We don't want to reevaluate on every dep here, cause we're changing the same deps inside
    // It will create a loop if we use every deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleChangeValue = (e) => {
    setValue(e.target.value);
    const contactSheet = contactSheetList?.find((c) => c.id === e.target.value);
    if (contactSheet) {
      setSelectedContactSheet(contactSheet);
      setOrientation(contactSheet.orientation);
    }
  };

  const handleChangeOrientation = (e) => {
    setOrientation(e.target.value);
  };

  return (
    <KContactSheetsModal
      className={className}
      close={close}
      contactSheetList={contactSheetList}
      count={count}
      handleChangeOrientation={handleChangeOrientation}
      handleChangeValue={handleChangeValue}
      id={id}
      loading={loading}
      onSelectContactSheet={onSelectContactSheet}
      open={open}
      orientation={orientation}
      selectedContactSheet={selectedContactSheet}
      testId={testId}
      value={value}
    />
  );
};

export default ContactSheets;
